module.exports = __webpack_public_path__ + "img/hk_lv1_product@3x.12efa531.png";